// react
import React from "react";

// @mui
import { Accordion, AccordionSummary, AccordionDetails, Box, Typography, Chip } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// A ---------------------------------------------------------------------- M

const DetailAccordion = ({ icon, title, count, expanded, onToggle, children, sx = {} }) => {
  return (
    <Accordion
      expanded={expanded}
      onChange={onToggle}
      disableGutters
      elevation={0}
      sx={{
        borderRadius: 3,
        overflow: "hidden",
        background: (theme) => `${theme.palette.background.paper}F2`,
        boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
        "&::before": { display: "none" },
        transition: "border-radius 0.25s ease",
        "&.Mui-expanded": {
          borderRadius: 3,
        },
        ...sx,
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          px: 2.2,
          py: 1.8,
          borderBottom: (theme) => `1px solid ${theme.palette.divider}40`,
          background: (theme) => `${theme.palette.background.paper}AA`,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {icon}

          <Typography variant="body1" fontWeight={700}>
            {title}
          </Typography>

          {count !== undefined && (
            <Chip
              label={count}
              size="small"
              sx={{
                ml: 1,
                height: 22,
                borderRadius: 2,
                fontSize: "0.75rem",
                fontWeight: 600,
              }}
            />
          )}
        </Box>
      </AccordionSummary>

      <AccordionDetails sx={{ p: 2.2 }}>{children}</AccordionDetails>
    </Accordion>
  );
};

export default DetailAccordion;
